// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--d8c34";
export var btn = "style-module--btn--45155";
export var container = "style-module--container--98ca6";
export var develop = "style-module--develop--8bc15";
export var experts = "style-module--experts--7e831";
export var gray = "style-module--gray--6a9e3";
export var logo = "style-module--logo--e7475";
export var orange = "style-module--orange--da6da";
export var violet = "style-module--violet--ae7ea";